<div class="fab" *ngIf="scrollBarsVisible">
  <button mat-icon-button>
    <mat-icon (click)="scrollUp()">keyboard_arrow_up</mat-icon>
  </button>
</div>